import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class AccountingObjectAPI extends DIApi {
  controllerName = 'AccountingObjects';

  /**
   * Lấy danh sách accounting object cho nhập số dư ban đầu (không giới hạn số lượng)
   */
  getInitialBalanceList(param) {
    const request = {
      url: this.getAPIUrl() + '/initial-balance-list',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new AccountingObjectAPI();
